import { v as i, x as t } from "./sharedStyles.js";
import { jsx as e, Fragment as a, jsxs as o } from "react/jsx-runtime";
import { uniqueId as d } from "@wds/utils";
import { T as n, a as l, b as s } from "./TableDataCell.js";
import { createUseStyles as r } from "react-jss";
function c(_ref) {
  var i = _ref.label,
    t = _ref.index,
    a = _ref.showStatisticalSignificance,
    o = _ref.showTitle;
  var d = "string" != typeof i,
    l = d ? i.name : i,
    s = d && i.suffix,
    r = d && i.totals,
    c = d && a && i.statisticalSignificanceLabel,
    h = o ? l : void 0,
    f = [];
  return 0 !== t && f.push("highlighted"), r && f.push("compact"), e(n, {
    name: l,
    title: h,
    suffix: s || void 0,
    totals: r || void 0,
    statisticalSignificanceLabel: c || void 0,
    className: f.join(" ")
  });
}
function h(_ref2) {
  var i = _ref2.options,
    t = _ref2.row,
    a = _ref2.index,
    o = _ref2.showTitle;
  var d, n;
  var s = (null === (d = i.fuzzyMatching) || void 0 === d ? void 0 : d.enabled) && t.fuzzyMatching ? {
      tooltip: null === (n = t.fuzzyMatching) || void 0 === n ? void 0 : n.tooltip
    } : void 0,
    r = i.functionFormat && t.function ? {
      handler: t.function,
      type: i.functionFormat,
      description: t.functionDescription
    } : void 0,
    c = o && !s ? t.name : void 0;
  return e(l, {
    name: t.name,
    title: c,
    index: a,
    identifier: i.rowIdentifier,
    color: t.color,
    event: r,
    fuzzyMatching: s
  });
}
function f(_ref3) {
  var i = _ref3.options,
    t = _ref3.row,
    o = _ref3.showStatisticalSignificance;
  var n = ["highlighted", "style-".concat(i.style)];
  return e(a, {
    children: t.data.map(function (_ref4) {
      var t = _ref4.value,
        a = _ref4.rendered,
        l = _ref4.statisticalSignificance;
      var r, c, h;
      var f = o ? {
        label: (null == l ? void 0 : l.label) || "",
        description: null == l ? void 0 : l.description,
        confidenceLevel: null === (r = i.statisticalSignificance) || void 0 === r ? void 0 : r.confidenceLevel
      } : void 0;
      return e(s, {
        value: a || "".concat(t.toFixed(null !== (c = i.decimals) && void 0 !== c ? c : 0)).concat(null !== (h = i.sufix) && void 0 !== h ? h : ""),
        className: n.join(" "),
        statisticalSignificance: f
      }, d("row-"));
    })
  });
}
function p(_ref5) {
  var _ref5$data = _ref5.data,
    a = _ref5$data === void 0 ? [{
      name: "",
      data: [{
        value: 0,
        rendered: "n/a"
      }]
    }] : _ref5$data,
    _ref5$options = _ref5.options,
    n = _ref5$options === void 0 ? {
      pivots: ["", ""]
    } : _ref5$options;
  var l, s, p;
  n.style || (n.style = "bold");
  var g = function (_ref6) {
      var e = _ref6.dataCount;
      return r(function (a) {
        return {
          singleWaveTable: Object.assign(Object.assign({}, i.table(a)), {
            width: "50%",
            "& th": Object.assign(Object.assign({}, i.th(a)), {
              minWidth: "10vw",
              padding: "16px",
              whiteSpace: "nowrap",
              "&.compact": {
                padding: "8px 12px 4px"
              },
              "&.highlighted": {
                borderTop: t.border.dark,
                borderLeft: t.border.light,
                "&:nth-of-type(2)": {
                  borderTopLeftRadius: "5px"
                },
                "&:last-of-type": {
                  borderTopRightRadius: "5px"
                }
              }
            }),
            "& td": Object.assign(Object.assign({}, i.td()), {
              padding: "4px 16px",
              textOverflow: "ellipsis",
              "&:first-child": {
                textAlign: "left",
                boxSizing: "border-box",
                padding: "16px 24px 16px 16px",
                maxWidth: t.sizes.dataLabel.fixedWidth
              },
              "&.style-bold": {
                backgroundColor: a.palette.background.main,
                fontWeight: a.type.fontWeight.medium,
                padding: "20px 16px"
              },
              "& .significance": {
                display: "block",
                color: "#757575",
                marginTop: "4px"
              },
              "&:not(:first-child)": {
                borderLeft: t.border.light
              }
            }),
            "& td, & th": {
              borderBottom: t.border.light,
              "&.highlighted": {
                "&:nth-of-type(2)": {
                  borderLeft: t.border.dark
                },
                "&:last-of-type": {
                  borderRight: t.border.dark
                }
              }
            },
            "& tr:last-of-type": {
              "& td.highlighted": {
                borderBottom: t.border.dark
              }
            },
            "&.style-simple": {
              tableLayout: "fixed",
              width: "100%",
              minWidth: "calc(".concat(t.sizes.data.minWidth, " * ").concat(e, " + ").concat(t.sizes.dataLabel.fixedWidth, ")"),
              maxWidth: "calc(".concat(t.sizes.data.maxWidth, " * ").concat(e, " + ").concat(t.sizes.dataLabel.fixedWidth, ")"),
              "& th": {
                "&:first-child": {
                  width: t.sizes.dataLabel.fixedWidth
                },
                "&:not(:first-child)": {
                  textOverflow: "ellipsis",
                  overflow: "hidden"
                }
              },
              "& td": {
                "&:first-child": {
                  textOverflow: "ellipsis",
                  overflow: "hidden"
                },
                "&:not(:first-child)": {
                  width: "calc((100% - ".concat(t.sizes.dataLabel.fixedWidth, ") / ").concat(e, ")")
                }
              }
            }
          })
        };
      })();
    }({
      dataCount: a ? null === (s = null === (l = a[0]) || void 0 === l ? void 0 : l.data) || void 0 === s ? void 0 : s.length : 1
    }),
    b = [g.singleWaveTable, "style-".concat(n.style)],
    u = (null === (p = n.statisticalSignificance) || void 0 === p ? void 0 : p.enabled) && !!a.find(function (_ref7) {
      var i = _ref7.data;
      return i.find(function (_ref8) {
        var i = _ref8.statisticalSignificance;
        return !!i;
      });
    }),
    v = "simple" === n.style;
  return a && a.length ? o("table", Object.assign({
    className: b.join(" ")
  }, {
    children: [e("thead", {
      children: e("tr", {
        children: n.pivots.map(function (i, t) {
          var a;
          return e(c, {
            label: i,
            index: t,
            showStatisticalSignificance: !!(null === (a = n.statisticalSignificance) || void 0 === a ? void 0 : a.enabled),
            showTitle: v
          }, d("header-"));
        })
      })
    }), e("tbody", {
      children: a.map(function (i, t) {
        return o("tr", {
          children: [e(h, {
            options: n,
            row: i,
            index: t,
            showTitle: !0
          }), e(f, {
            options: n,
            row: i,
            showStatisticalSignificance: !!u
          })]
        }, d("row-"));
      })
    })]
  })) : e("div", {});
}
export { p as S };